import { datadogLogs } from '@datadog/browser-logs';
import {
  getCommentEditorState,
  readCommentContent,
} from '@main/shared/utils/lexical/comment-content';
import { useEffect, useMemo } from 'react';

/**
 * Removes the stored `editorState` wrapper. Plain text, and editor states the
 * comment editor cannot load, are shown as their stored text instead.
 */
export const useGetCommentState = (text: string, commentId?: string) => {
  const content = useMemo(() => readCommentContent(text), [text]);

  useEffect(() => {
    if (content.kind === 'unsupported-editor-state') {
      datadogLogs.logger.warn('Comment has an unsupported editor state; showing its stored text', {
        commentId,
      });
    }
  }, [content.kind, commentId]);

  return useMemo(() => JSON.stringify(getCommentEditorState(content)), [content]);
};
